<script>
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';

export default {
  name: 'RiskAnalysisForm',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
  },
  props: {
    procedureDirectory: {
      type: Object,
      required: true,
    },
  },
};
</script>

<template>
  <v-form>
    <v-container fluid grid-list-lg pt-2 pa-0>
      <v-layout row wrap>
        <!-- eslint-disable -->
        <v-flex xs12 md6 py-0>
          <v-radio-group v-model="procedureDirectory.recoveryInterestLevel" column label="Wie schutzbedürftig sind die Daten für den Betroffenen?">
            <v-radio label="Gering (Daten sind öffentlich bekannt oder bei einer Veröffentlichung ist ein geringer Schaden zu erwarten) ist kein Vernachlässigbar (die Daten sind bereits öffentlich oder bei einer Veröffentlichung ist kein unvertretbarer Schaden zu befürchten)" :value="0"/>
            <v-radio label="Normal (Bei einem Bekanntwerden der Daten ist mit einem durchschnittlichen Schaden zu rechnen Normal (ein möglicher Datenmissbrauch hätte vertretbare Auswirkungen auf wirtschaftliche und persönliche Verhältnisse des Betroffenen)." :value="1"/>
            <v-radio label="Hoch (Es handelt sich um sensible Daten und bei Bekanntwerden sind erhebliche wirtschaftliche und persönliche Folgen zu erwarten unbefugter Veröffentlichung weitreichende Konsequenzen wirtschaftlicher und persönlicher Art)." :value="2" />
            <v-radio label="Sehr hoch (Bei Bekanntwerden der hochsensiblen Daten sind existenzgefährdende wirtschaftliche und gesellschaftliche Folgen zu befürchten)." :value="3" />
          </v-radio-group>
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-textarea
            v-model="procedureDirectory.recoveryInterestLevelNotes"
            label="Kommentar"
            class="caption"
          />
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-radio-group v-model="procedureDirectory.attackProbability" column label="Wie hoch ist die Eintrittswahrscheinlichkeit?">
            <v-radio label="Gering (Die Daten sind für einen Dritten kaum oder nicht verwertbar, zusätzlich sind die Daten sehr stark gesichert)." value="0"/>
            <v-radio label="Normal (Bei den personenbezogenen Daten besteht für Dritte ein Verwertungsinteresse. Dabei besteht eine niedrige Wahrscheinlichkeit, dass die Daten abgeschöpft werden, es besteht ein angemessenes Sicherheitsniveau zum Schutz der Daten.)" :value="1"/>
            <v-radio label="Hoch (Bei den hier zugrundeliegenden Daten besteht ein großes Verwertungsinteresse für Angreifer und damit besteht auch die Gefahr einer entsprechend hohen Investition in einen Angriff.)." :value="2" />
            <v-radio label="Sehr Hoch (Bei den hier zugrundeliegenden Daten besteht ein sehr großes Verwertungsinteresse und ist ein entsprechend sehr hoher Einsatz von potentiellen Angreifern zu erwarten.)" :value="3" />
          </v-radio-group>
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-textarea
            v-model="procedureDirectory.attackProbabilityNotes"
            label="Kommentar"
            class="caption"
          />
        </v-flex>

        <v-flex xs12 md6 py-0>
          <span class="caption"> Kriterien</span>
          <v-checkbox
            v-model="procedureDirectory.hasScoring"
            label="Bewertung oder Scoring"
            class="caption"
            height="20"
            hide-details
          />
          <v-checkbox
            v-model="procedureDirectory.hasAutoDecision"
            label="Automatisierte Entscheidung, die eine rechtliche Auswirkung beinhaltet. (insbesondere bei Gefahr der Diskriminierung und Ausschluss von Personen)"
            class="caption"
            height="20"
            hide-details
          />
          <v-checkbox
            v-model="procedureDirectory.hasMethodicalMonitoring"
            label="Systematisches Monitoring"
            class="caption"
            height="20"
            hide-details
          />
          <v-checkbox
            v-model="procedureDirectory.hasSensitiveData"
            label="Sensible Daten oder Daten höchst persönlicher Art (besondere Kategorien personenbezogener Daten nach Artikel 9 DSGVO)"
            class="caption"
            height="20"
            hide-details
          />
          <v-checkbox
            v-model="procedureDirectory.hasMajorDataProcessing"
            label="Verarbeitung von Daten in erheblichem Ausmaß"
            class="caption"
            height="20"
            hide-details
          />
          <v-checkbox
            v-model="procedureDirectory.hasUnexpectedDataProcessing"
            label="Abgleich oder Kombination von Datensätzen, welche zu unterschiedlichen Zwecken verarbeitet werden und was außerhalb des Erwartungshorizonts der Betroffenen liegt."
            class="caption"
            height="20"
            hide-details
          />
          <v-checkbox
            v-model="procedureDirectory.hasModernSolutions"
            label="Neuartige Nutzung oder Gebrauch neuer technologischer oder organisatorischer Lösungen"
            class="caption"
            height="20"
            hide-details
          />
          <v-checkbox
            v-model="procedureDirectory.hasRestrictions"
            label="Wenn betroffene Personen durch die Verarbeitung der Zugang zu einem Recht, der Inanspruchnahme einer Dienstleistung oder der Abschluss eines Vertrags verhindert, geändert oder erlaubt wird."
            class="caption"
            height="20"
            hide-details
          />
          <v-checkbox
            v-model="procedureDirectory.hasNoCriteria"
            label="Keine der Kriterien liegen vor"
            class="caption"
            height="20"
            hide-details
          />
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-checkbox
            v-model="procedureDirectory.isRiskAnalysisClosed"
            label="Abgeschlossen"
            class="caption"
            hide-details
          />
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>
